export default  {
    
    state: {
      isSysAdmin: false, 
      projectId: undefined,  
      project: "< Select project",
      modules: [],
      userJournals: [],
      breadcrumbs: [],
        
      },
  
      setItem (item, val){
          this.state[item] = val;
      },
      saveState(){
        window.sessionStorage.setItem("state", JSON.stringify(this.state));
      },
      loadState(){
        if (window.sessionStorage.length > 0) {
          this.state = JSON.parse(window.sessionStorage.getItem("state"));
        }
        
      },
    };